import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { EstateTaxFormTypeKey } from '@/modules/estatetaxform/enums/EstateTaxFormTypeKey';

export class EstateTaskTaxFormStatus extends Enum {
  static TODO = {
    key: 'todo',
    get value() {
      return Lang.t('estate.to-do');
    },
    color: '#7E84A3'
  };

  static IN_PROGRESS = {
    key: 'in_progress',
    get value() {
      return Lang.t('estatetask.in-progress');
    },
    color: '#EE964B'
  };

  static WAITING_FOR_SIGNATURE = {
    key: 'waiting_for_signature',
    get value() {
      return Lang.t('estatetask.waiting-for-signature');
    },
    color: '#4b7658'
  };

  static WAITING_FOR_PROBATE = {
    key: 'waiting_for_probate',
    get value() {
      return Lang.t('estatetask.waiting-for-probate');
    },
    color: '#61243a'
  };

  static PEER_REVIEW = {
    key: 'peer_review',
    get value() {
      return Lang.t('estatetask.peer-review');
    },
    color: '#5bccc0'
  };

  static REVIEW_QUERIES = {
    key: 'review_queries',
    get value() {
      return Lang.t('estatetask.review-queries');
    },
    color: '#856e49'
  };

  static READY_TO_DELIVER = {
    key: 'ready_to_deliver',
    get value() {
      return Lang.t('estatetask.ready-to-deliver');
    },
    color: '#465353'
  };

  static SUBMITTED_TO_CRA = {
    key: 'submitted_to_cra',
    get value() {
      return Lang.t('estatetask.submitted-cra-to');
    },
    color: '#2E7D5F'
  };

  // TODO: remove
  static ACCEPTED = {
    key: 'accepted',
    get value() {
      return Lang.t('estatetask.accepted');
    },
    color: '#61D098'
  };

  // TODO: remove
  static REASSESSING = {
    key: 'reassessing',
    get value() {
      return Lang.t('estatetask.reassessing');
    },
    color: '#F97068'
  };

  static NOT_APPLICABLE = {
    key: 'not_applicable',
    get value() {
      return Lang.t('estate.not-applicable');
    },
    color: '#C4C4C4'
  };

  static CLIENT_REVIEWING = {
    key: 'client_reviewing',
    get value() {
      return Lang.t('estatetask.client-reviewing');
    },
    color: '#9747FF'
  };

  static WAITING_FOR_DOCUMENTS = {
    key: 'waiting_for_documents',
    get value() {
      return Lang.t('estatetask.waiting-for-documents');
    },
    color: '#d5bbfd'
  };

  static COMPLETED = {
    key: 'completed',
    get value() {
      return Lang.t('estatetask.completed');
    },
    color: '#2E7D5F'
  };

  static NOT_REQUIRED = {
    key: 'not_required',
    get value() {
      return Lang.t('estatetask.not-required');
    },
    color: '#95211B'
  };

  static LEGAL_REP_TO_CRA = {
    key: 'legal_rep_to_cra',
    get value() {
      return Lang.t('estatetask.legal-rep-to-cra');
    },
    color: '#D919DD'
  };

  static WAITING_APPROVAL = {
    key: 'waiting_approval',
    get value() {
      return Lang.t('estatetask.waiting-auth-rep-approval');
    },
    color: '#9747FF'
  };

  static SEND_TO_CRA = {
    key: 'send_to_cra',
    get value() {
      return Lang.t('estatetask.send-to-cra');
    },
    color: '#1305B8'
  };

  static EFILED_WAITING_FOR_NOA = {
    key: 'efiled_waiting_for_noa',
    get value() {
      return Lang.t('estatetask.efiled-waiting-for-noa');
    },
    color: '#60C49D'
  };

  static TO_CLIENT_TO_SIGN = {
    key: 'to_client_to_sign',
    get value() {
      return Lang.t('estatetask.to-client-to-sign');
    },
    color: '#D919DD'
  };

  static FILED_WITH_IRS = {
    key: 'filed_with_irs',
    get value() {
      return Lang.t('estatetask.filed-with-irs');
    },
    color: '#60C49D'
  };

  static WITH_EP = {
    key: 'with_ep',
    get value() {
      return Lang.t('estatetask.with-ep');
    },
    color: '#60C49D'
  };

  static COLLECT_T3_DOCS = {
    key: 'collect_t3_docs',
    get value() {
      return Lang.t('estatetask.collect-t3-docs');
    },
    color: '#AE10E8'
  };

  static IN_REVIEW = {
    key: 'in_review',
    get value() {
      return Lang.t('estatetask.in-review');
    },
    color: '#9747FF'
  };

  static SENT_TO_CLIENT = {
    key: 'sent_to_client',
    get value() {
      return Lang.t('estatetask.sent-to-client');
    },
    color: '#1305B8'
  };

  static PREPARATION = {
    key: 'preparation',
    get value() {
      return Lang.t('estatetask.preparation');
    },
    color: '#EE964B'
  };

  static WAIT_EFILE_CONFIRM = {
    key: 'wait_efile_confirm',
    get value() {
      return Lang.t('estatetask.wait-efile-confirm');
    },
    color: '#9747FF'
  };

  static EFILE_COMPLETE = {
    key: 'efile_complete',
    get value() {
      return Lang.t('estatetask.efile-complete');
    },
    color: '#60C49D'
  };

  static SENT_TO_CLIENT_TO_PAPERFILE = {
    key: 'sent_to_client_to_paperfile',
    get value() {
      return Lang.t('estatetask.sent-to-client-to-paperfile');
    },
    color: '#2E7D5F'
  };

  static getClosedStatuses() {
    return [
      EstateTaskTaxFormStatus.SENT_TO_CLIENT_TO_PAPERFILE.key,
      EstateTaskTaxFormStatus.NOT_REQUIRED.key,
      EstateTaskTaxFormStatus.EFILE_COMPLETE.key,
      EstateTaskTaxFormStatus.FILED_WITH_IRS.key,
      EstateTaskTaxFormStatus.COMPLETED.key
    ];
  }

  static getAuthRepFormStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.LEGAL_REP_TO_CRA,
      EstateTaskTaxFormStatus.PREPARATION,
      EstateTaskTaxFormStatus.SENT_TO_CLIENT,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.WAITING_APPROVAL,
      EstateTaskTaxFormStatus.COMPLETED,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getT1Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.WAITING_FOR_PROBATE,
      EstateTaskTaxFormStatus.WAITING_FOR_DOCUMENTS,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.PEER_REVIEW,
      EstateTaskTaxFormStatus.REVIEW_QUERIES,
      EstateTaskTaxFormStatus.READY_TO_DELIVER,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.EFILED_WAITING_FOR_NOA,
      EstateTaskTaxFormStatus.COMPLETED,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getT3Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.WAITING_FOR_PROBATE,
      EstateTaskTaxFormStatus.WAITING_FOR_DOCUMENTS,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.PEER_REVIEW,
      EstateTaskTaxFormStatus.REVIEW_QUERIES,
      EstateTaskTaxFormStatus.READY_TO_DELIVER,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.EFILED_WAITING_FOR_NOA,
      EstateTaskTaxFormStatus.COMPLETED,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getT1AdjustmentStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.COMPLETED
    ];
  }

  static getT3AdjustmentStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.COLLECT_T3_DOCS,
      EstateTaskTaxFormStatus.COMPLETED,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getClearanceCertificateStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.WITH_EP,
      EstateTaskTaxFormStatus.IN_REVIEW,
      EstateTaskTaxFormStatus.SENT_TO_CLIENT,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.COMPLETED,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getRC4288Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.SEND_TO_CRA,
      EstateTaskTaxFormStatus.COMPLETED
    ];
  }

  static getForm56Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.PREPARATION,
      EstateTaskTaxFormStatus.SENT_TO_CLIENT_TO_PAPERFILE,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static get1040Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.PREPARATION,
      EstateTaskTaxFormStatus.CLIENT_REVIEWING,
      EstateTaskTaxFormStatus.WAITING_FOR_SIGNATURE,
      EstateTaskTaxFormStatus.WAIT_EFILE_CONFIRM,
      EstateTaskTaxFormStatus.EFILE_COMPLETE,
      EstateTaskTaxFormStatus.FILED_WITH_IRS,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static get1041Statuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.PREPARATION,
      EstateTaskTaxFormStatus.CLIENT_REVIEWING,
      EstateTaskTaxFormStatus.WAITING_FOR_SIGNATURE,
      EstateTaskTaxFormStatus.WAIT_EFILE_CONFIRM,
      EstateTaskTaxFormStatus.EFILE_COMPLETE,
      EstateTaskTaxFormStatus.FILED_WITH_IRS,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static get1040AdjustmentStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.FILED_WITH_IRS,
      EstateTaskTaxFormStatus.COMPLETED
    ];
  }

  static get1041AdjustmentStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.IN_PROGRESS,
      EstateTaskTaxFormStatus.TO_CLIENT_TO_SIGN,
      EstateTaskTaxFormStatus.FILED_WITH_IRS,
      EstateTaskTaxFormStatus.COMPLETED
    ];
  }

  static getIRSTerminationStatuses() {
    return [
      EstateTaskTaxFormStatus.TODO,
      EstateTaskTaxFormStatus.PREPARATION,
      EstateTaskTaxFormStatus.SENT_TO_CLIENT_TO_PAPERFILE,
      EstateTaskTaxFormStatus.WAIT_EFILE_CONFIRM,
      EstateTaskTaxFormStatus.NOT_REQUIRED
    ];
  }

  static getStatusesByType(key) {
    switch (key) {
      case EstateTaxFormTypeKey.AUTH_REP_FORM:
        return EstateTaskTaxFormStatus.getAuthRepFormStatuses();
      case EstateTaxFormTypeKey.T1:
        return EstateTaskTaxFormStatus.getT1Statuses();
      case EstateTaxFormTypeKey.T3:
        return EstateTaskTaxFormStatus.getT3Statuses();
      case EstateTaxFormTypeKey.T1_ADJUSTMENT:
        return EstateTaskTaxFormStatus.getT1AdjustmentStatuses();
      case EstateTaxFormTypeKey.T3_ADJUSTMENT:
        return EstateTaskTaxFormStatus.getT3AdjustmentStatuses();
      case EstateTaxFormTypeKey.CLEARANCE_CERTIFICATE:
        return EstateTaskTaxFormStatus.getClearanceCertificateStatuses();
      case EstateTaxFormTypeKey.RC4288:
        return EstateTaskTaxFormStatus.getRC4288Statuses();
      case EstateTaxFormTypeKey.FORM_56:
        return EstateTaskTaxFormStatus.getForm56Statuses();
      case EstateTaxFormTypeKey.TEN_FORTY:
        return EstateTaskTaxFormStatus.get1040Statuses();
      case EstateTaxFormTypeKey.TEN_FORTY_ONE:
        return EstateTaskTaxFormStatus.get1041Statuses();
      case EstateTaxFormTypeKey.TEN_FORTY_ADJUSTMENT:
        return EstateTaskTaxFormStatus.get1040AdjustmentStatuses();
      case EstateTaxFormTypeKey.TEN_FORTY_ONE_ADJUSTMENT:
        return EstateTaskTaxFormStatus.get1041AdjustmentStatuses();
      case EstateTaxFormTypeKey.IRS_TERMINATION:
        return EstateTaskTaxFormStatus.getIRSTerminationStatuses();
      default:
        return [];
    }
  }
}
